<template>
    <div>
      <h3 class="mt-3 mb-base">Capital Gain Report</h3>
      <div>
        <!-- filters  -->
        <vs-row>
          <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="pl-0 pr-1 mb-3">
              <SelectForeign
                  :model.sync="filters.portfolio"
                  label="Select by Portfolio"
                  placeholder="Type to Search"
                  :multiple="true"
                  :load_initial="true"
                  :label_keys="['name', ]"
                  label_class="mb-0"
                  input_class="mt-0 bg-white"
                  :show_id_in_label="false"
                  :endpoint="$store.state.apiendpoints.portfolio_list"
                  :use_id_as_value="false"
                  :disabled="loading"
                  list_length="10000"
              />
            <small class="block text-danger mt-1" v-if="api_errors && api_errors.portfolio">
                {{ api_errors.portfolio.join(', ') }}
            </small>
          </vs-col>
          <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="pl-0 pr-1 mb-3">
            <SelectDate :disabled="loading" :selectedDate.sync="filters.from_trade_date" label="Select by From Date" />
            <small class="block text-danger mt-1" v-if="api_errors && api_errors.from_trade_date">
                {{ api_errors.from_trade_date.join(', ') }}
            </small>
          </vs-col>
          <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="pl-0 pr-1 mb-3">
            <SelectDate :disabled="loading" :selectedDate.sync="filters.to_trade_date" label="Select by To Date" />
            <small class="block text-danger mt-1" v-if="api_errors && api_errors.to_trade_date">
                {{ api_errors.to_trade_date.join(', ') }}
            </small>
          </vs-col>
          <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="pl-0 pr-1 mb-3">
              <SelectForeign
                  :model.sync="filters.scrip"
                  label="Select by Scrip"
                  placeholder="Type to Search"
                  :multiple="false"
                  :load_initial="true"
                  :label_keys="['name', ]"
                  label_class="mb-0"
                  input_class="mt-0 bg-white"
                  :show_id_in_label="false"
                  :endpoint="$store.state.apiendpoints.share_list"
                  :use_id_as_value="true"
                  :disabled="loading"
                  list_length="10000"
              />
            <small class="block text-danger mt-1" v-if="api_errors && api_errors.scrip">
                {{ api_errors.scrip.join(', ') }}
            </small>
          </vs-col>
        </vs-row>

        <!-- list of excel created  -->
        <template v-if="ongoing_exports.length">
          <vs-alert color="primary" v-if="loading_exports">
              Loading Latest Exports, please wait..
          </vs-alert>
          <template v-else>
              <template v-for="(item, index) in ongoing_exports">
                  <vs-alert color="primary" :key="index" class="mb-2">
                      <template v-if="item.status == 'p'">
                          Your export is pending, please check back in few minutes
                      </template>
                      <template v-else-if="item.status == 's'">
                          Your export is in queue, please check back in few minutes
                      </template>
                      <template v-else-if="item.status == 'r'">
                          Your export is being generated, please check back in few minutes
                      </template>
                      <template v-else-if="item.status == 'c'">
                          Your export has been completed. (<FormatText :text="item.created_on" format="datetime" />) <a :href="item.export_excel" target="_blank" style="float:right;"><vs-button size="small">Download</vs-button></a>
                      </template>
                      <template v-else-if="item.status == 'f'">
                          Your export has been failed, please request again!
                      </template>
                  </vs-alert>
              </template>
          </template>
        </template>

        <vs-button color="primary" type="filled" @click="create_excel"  class="mt-base" :disabled="loading">Create Excel</vs-button>
      </div>
    </div>
  </template>
  
  <script>
  import { Request } from "../../utils/requests";
  import SelectDate from "../../components/letstream/ls-select-date/SelectDate.vue"

  export default {
    components: {
        SelectDate
    },
    props: {
      embedded_mode: {
        default: false,
      },
      embedded_filters: {
        default: null,
      },
    },
    data() {
  
      return {
        loading: false,

        filters: {
          portfolio: [],
          scrip: null,
          from_trade_date: null,
          to_trade_date: null,
        },

        api_errors: {},

        loading_exports: false,
        ongoing_exports: []
      };
    },
    mounted() {
      this.timer = null;
      this.init();
    },
    watch: {
      filters: {
        deep: true,
        handler(newV) {
  
          if (this.timer) clearTimeout(this.timer);
  
          this.timer = setTimeout(() => {
            this.$router.push({ name: this.$route.name, query: newV });
          }, 800);
        },
      },
    },
    beforeDestroy() {
      if (this.export_timer) clearTimeout(this.export_timer)
    },
    methods: {
      init() {
        this.refresh_exports();
      },
      checking_for_filters() {
        if (!this.filters.portfolio.length) {
            this.api_errors = {
                "portfolio": [
                    "Portfolio is required.",
                ]
            }
            return true
        } 

        if(!this.filters.from_trade_date) {
            this.api_errors = {
                "from_trade_date": [
                    "From Date is required.",
                ]
            }
            return true
        }

        if(!this.filters.to_trade_date) {
            this.api_errors = {
                "to_trade_date": [
                    "To Date is required.",
                ]
            }
            return true
        }

        if(!this.filters.to_trade_date) {
            this.api_errors = {
                "to_trade_date": [
                    "To Date is required.",
                ]
            }
            return true
        }

        if(this.filters.from_trade_date > this.filters.to_trade_date) {
            this.api_errors = {
                "from_trade_date": [
                    "From Date should be less than To Date.",
                ]
            }

            return true
        }

        return false
      },
      refresh_exports() {
        this.loading_exports = true

        let url = this.$store.state.apiendpoints.excel_list

        let payload = {
            created_on: new Date().toISOString().split("T")[0],
            params__report_type: 'capital_gain',
            limit: 2
        }

        Request(this, 'GET', url, payload).then(
            (res) => {
                this.ongoing_exports = res.results
                this.loading_exports = false
                if(this.ongoing_exports.filter((item) => ['p', 's', 'r'].includes(item.status)).length != 0) this.auto_refresh_export()
            }, 
            (err) => {
                this.loading_exports = false;
                this.$vs.notify({
                    time: 2500,
                    title: 'Error',
                    text: "Unable to load current exports, please refresh to try again!",
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            }
        )
      },
      auto_refresh_export() {
        this.export_timer = setTimeout(() => {
            this.refresh_exports()
        }, 5000);
      },
      create_excel() {

        if(this.checking_for_filters()) return

        this.loading = true;
        this.$vs.loading();

        let payload = {
            params: {
                "report_type": 'capital_gain',
                "filters": this.filters
            }
        }

        let url = this.$store.state.apiendpoints.excel_create

        Request(this, 'POST', url, null, payload).then(
            (res) => {
                this.api_errors = {}
                this.loading = false;
                this.$vs.loading.close();

                this.refresh_exports()

                this.$vs.notify({
                    time: 3000,
                    title: 'Success',
                    text: "Your request to download file has been submitted",
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success'
                })
            },
            (err) => {
                this.api_errors = {}
                this.loading = false;
                this.$vs.loading.close();
                if (err.error) {
                    this.api_errors = err.error

                    this.$vs.notify({
                      time: 2500,
                      title: 'Error',
                      text: "Please fix the errors and try again!",
                      iconPack: 'feather',
                      icon: 'icon-alert-circle',
                      color: 'danger'
                    })
                } else {
                    this.$vs.notify({
                        time: 2500,
                        title: 'Error',
                        text: "Please try again later.",
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                }
            }
        )
      },
    },
  };
  </script>